<template>
  <div
    class="modal-mask"
    role="dialog"
  >
    <div class="overlay-mask">
      <div class="modal-dialog modal-md" style="max-width: 1140px;">
        <div class="modal-content modal-edit-bg" style="padding: 16px;">
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
                <div
                  class="close_btn"
                  v-on:click="CloseModal()"
                ></div><br>
                <div class="row long-modal">
                  <div
                    class=""
                    style="width:100%; padding: 1px;"
                  >
                    <iframe
                      :id="jotFormElementID"
                      title="Equipment Request Form"
                      onload="window.parent.scrollTo(0,20)"
                      allowtransparency="true"
                      allowfullscreen="true"
                      allow="geolocation; microphone; camera"
                      :src="'https://form.jotform.com/' + formID + '?' + prefillFields"
                      frameborder="0"
                      style=" min-width: 100%; height:800px; border:none;"
                      scrolling="no"
                    > </iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
export default {
  props: ["Account", "formID"],
  components: {},
  data() {
    return {
      isModalShown: false,
      prefillFields: null,
      jotFormPrefills: null
    }
  },
  methods: {
    CloseModal() {
      this.$emit("closeJotForm");
    },
    ShowJotForm() {
      var _this = this;
      var ifr = document.getElementById("JotFormIFrame-" + this.formID);
      if (window.location.href && window.location.href.indexOf("?") > -1) {
        var get = window.location.href.substr(
          window.location.href.indexOf("?") + 1
        );
        if (ifr && get.length > 0) {
          var src = ifr.src;
          src = src.indexOf("?") > -1 ? src + "&" + get : src + "?" + get;
          ifr.src = src;
        }
      }
      window.handleIFrameMessage = function (e) {
        if (typeof e.data === "object") {
          return;
        }
        var args = e.data.split(":");
        var iframe = null;
        if (args.length > 2) {
          iframe = document.getElementById(
            "JotFormIFrame-" + args[args.length - 1]
          );
        } else {
          iframe = document.getElementById("JotFormIFrame");
        }
        if (!iframe) {
          return;
        }
        switch (args[0]) {
          case "scrollIntoView":
            iframe.scrollIntoView();
            break;
          case "setHeight":
            iframe.style.height = args[1] + "px";
            break;
          case "collapseErrorPage":
            if (iframe.clientHeight > window.innerHeight) {
              iframe.style.height = window.innerHeight + "px";
            }
            break;
          case "reloadPage":
            window.location.reload();
            break;
          case "loadScript":
            var src = args[1];
            if (args.length > 3) {
              src = args[1] + ":" + args[2];
            }
            var script = document.createElement("script");
            script.src = src;
            script.type = "text/javascript";
            document.body.appendChild(script);
            break;
          case "exitFullscreen":
            if (window.document.exitFullscreen)
              window.document.exitFullscreen();
            else if (window.document.mozCancelFullScreen)
              window.document.mozCancelFullScreen();
            else if (window.document.mozCancelFullscreen)
              window.document.mozCancelFullScreen();
            else if (window.document.webkitExitFullscreen)
              window.document.webkitExitFullscreen();
            else if (window.document.msExitFullscreen)
              window.document.msExitFullscreen();
            break;
        }
        var isJotForm = e.origin.indexOf("jotform") > -1 ? true : false;
        if (
          isJotForm &&
          "contentWindow" in iframe &&
          "postMessage" in iframe.contentWindow
        ) {
          var urls = {
            docurl: encodeURIComponent(document.URL),
            referrer: encodeURIComponent(document.referrer),
          };
          iframe.contentWindow.postMessage(
            JSON.stringify({ type: "urls", value: urls }),
            "*"
          );
        }
      };
      if (window.addEventListener) {
        window.addEventListener("message", handleIFrameMessage, false);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", handleIFrameMessage);
      }
      this.isWufooLoading = false;
    },
  },
  async created() {
    this.isWufooLoading = true;
     this.jotFormElementID = "JotFormIFrame-" + this.formID;
     try {
      var response = await fetch(Vue.config.API_ENDPOINT + 'CMS/GetJotFormPrefills/' + this.formID, {
          method: 'get',
          headers: {
              'Authorization': "Bearer " + localStorage.getItem("token")
          }
      })
      this.jotFormPrefills = await response.json();
      console.log(this.jotFormPrefills);

      var organizationName = this.Account.accountType === 1
            ? this.Account.primaryContact.firstName + ' ' + this.Account.primaryContact.lastName + ' ' + this.Account.primaryContact.suffix
            : this.Account.primaryContact.legalName;

      let preFillArray = [];
      for (let field of this.jotFormPrefills)
      {
        console.log(field);
        if (field.valueType == "CONSTANT")
        {
          preFillArray.push( field.fieldName + "=" + field.value);
        }
        else if (field.value === "organizationName")
        {
          preFillArray.push( field.fieldName + "=" + organizationName);
        }
        else
        {
          let elements = field.value.split('.');
          let valueP = elements.reduce((v, e) => v[e], this.Account)

          console.log(valueP);
          console.log(elements);
          let value = this.Account;
          for(let key of elements)
            if (value[key] !== undefined)
              value = value[key];
            else
            {
              value = null;
              break;
            }
          console.log(value);

          if (value != null)
            preFillArray.push(field.fieldName + "=" + value);
        }
      }
      console.log(preFillArray);
      this.prefillFields = preFillArray.join('&');
      console.log(this.prefillFields);
    } catch(ex) {
        console.log(ex);
    }

    this.ShowJotForm();
  },
};
</script>
<style>
@import '../../../static/sass/resource-modal.scss';
</style>






// WEBPACK FOOTER //
// JotformModal.vue?1a72a269